import type { IVariantSummary } from "~/hooks/useVariantTableData"
import {
  readLeadTimeAvailability,
  sumLeadTimeAvailability,
} from "~/utils/stockProjection/leadTimeAvailability"
import type { LeadTimeAvailability } from "~/utils/stockProjection/types"

type LeadTimeBySku = Map<string, Record<string, LeadTimeAvailability | undefined>> | undefined

// Re-derives the warehouse-dependent fields Triggers reads, so a card-local warehouse filter
// needn't flip the app-wide store. Assumes the store itself is unscoped (all warehouses).
export function scopeVariantToWarehouse(
  variant: IVariantSummary,
  warehouseId: string | undefined,
  leadTimeBySku: LeadTimeBySku,
): IVariantSummary {
  if (!warehouseId) return variant
  const leadTime = sumLeadTimeAvailability(
    variant.skuIds.map((skuId) => readLeadTimeAvailability(leadTimeBySku?.get(skuId), warehouseId)),
  )
  const stockLevelDetails = variant.stockLevelDetails.filter((s) => s.warehouseId === warehouseId)
  const incomingOrders = variant.incomingOrders.filter((o) => o.warehouseId === warehouseId)
  return {
    ...variant,
    outOfStockInformation: variant.stockOutInfoWarehouse[warehouseId] ?? [],
    stockOutInfoWarehouse: { [warehouseId]: variant.stockOutInfoWarehouse[warehouseId] ?? [] },
    availabilityWithinLeadTime: leadTime,
    lostSalesWithinLeadTime: Math.round(leadTime.lostSales),
    stockLevelDetails,
    stockLevel: stockLevelDetails.reduce((sum, s) => sum + s.closingStock, 0),
    incomingOrders,
    incomingStock: incomingOrders.reduce((sum, o) => sum + o.quantity, 0),
  }
}
